// extracted by mini-css-extract-plugin
export var blogHeader = "blog-post-module--blogHeader--k0nUn";
export var blogPost = "blog-post-module--blogPost--j0AIH";
export var blogPostBottom = "blog-post-module--blogPostBottom--QNGRx";
export var date = "blog-post-module--date--lqWgF";
export var footer = "blog-post-module--footer--tQFZs";
export var navLinks = "blog-post-module--navLinks--u7ygs";
export var postBody = "blog-post-module--postBody--SlwfU";
export var title = "blog-post-module--title--oIdH5";